import { Avatar, Chip, Typography, styled } from '@mui/material';
import Button from 'src/components/Button/Button';
import SvgIcon from 'src/components/SvgIcon/SvgIcon';

export const StyledListRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.5, 1),
  borderBottom: `1px solid ${theme.palette.custom.grey[50]}`
}));

export const StyledListRowMetadata = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.75)
}));

export const StyledListRowAvatar = styled(Avatar)(({ theme }) => ({
  width: '32px',
  height: '32px',
  backgroundColor: theme.palette.custom.coralDusk[50],
  color: theme.palette.custom.coralDusk[400],
  ...theme.typography.body2,
  letterSpacing: '-0.01em'
}));

export const StyledListRowActionButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-sizeLarge': {
    padding: '1.5px 6.5px'
  },
  '&.MuiButton-textPrimary': {
    color: theme.palette.custom.grey[300],

    ':hover': {
      backgroundColor: 'transparent',
      color: theme.palette.custom.grey[300]
    }
  }
}));

export const StyledRightSide = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledInviteExpiredChip = styled(Chip)(({ theme }) => ({
  borderRadius: '6px',

  '.MuiChip-label': {
    padding: theme.spacing(0.25, 1),

    '.MuiTypography-root': {
      fontSize: '12px'
    }
  }
}));

/* TODO: Add helper CSS styles for common scenarios */
export const StyledEmptyExistingMembersList = styled('div')(({ theme }) => ({
  display: 'flex',
  maxWidth: '352px',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  margin: '140px auto 0',
  textAlign: 'center'
}));

export const StyledEmptyExistingMembersListIcon = styled(SvgIcon)(({ theme }) => ({
  width: '80px',
  height: '80px',
  marginBottom: theme.spacing(1)
}));

export const StyledEmptyExistingMembersListDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.grey[600],
  letterSpacing: '-0.01em',
  textAlign: 'center'
}));
